<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M14.7222 3.05555H5.27777C4.05047 3.05555 3.05555 4.05047 3.05555 5.27777V14.7222C3.05555 15.9496 4.05047 16.9444 5.27777 16.9444H14.7222C15.9496 16.9444 16.9444 15.9496 16.9444 14.7222V5.27777C16.9444 4.05047 15.9496 3.05555 14.7222 3.05555Z"
            fill="var(--card-success-background-light)"
        />
        <path
            d="M6.38889 10.2778L8.88889 13.0556L13.6111 6.94447"
            stroke="var(--icons-success-accent)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.7222 3.05555H5.27777C4.05047 3.05555 3.05555 4.05047 3.05555 5.27777V14.7222C3.05555 15.9496 4.05047 16.9444 5.27777 16.9444H14.7222C15.9496 16.9444 16.9444 15.9496 16.9444 14.7222V5.27777C16.9444 4.05047 15.9496 3.05555 14.7222 3.05555Z"
            stroke="var(--icons-success-accent)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
